import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { cn } from '@/utils/cn';

export function AppShell() {
  const toggleSidebar = useAppStore((s) => s.toggleSidebar);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      const store = useAppStore.getState();

      if (isMobile && !store.sidebarCollapsed) {
        toggleSidebar();
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [toggleSidebar]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <div className="flex flex-1">
        <Sidebar />
        <main
          className={cn(
            'flex-1 min-w-0 overflow-auto transition-all duration-200',
            'pb-16 md:pb-0'
          )}
        >
          <div className="p-4 md:p-6 max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
